const Home = () => {
    return (
        <div>
            {window.location.replace("https://combokid.com")}
        </div>
    );
};

export default Home;